import React, { useState } from "react";
import MonthFilterSelect from "../../../../Component/DigitalMarketing/MonthFilter";
import { useGetLeadsServiceTypeQuery, useGetTopConsultantsQuery } from "../../../../Service/dashboard";
import allConsultant from "../../../../assets/DigitalMarketing/image/allconsultant.svg";
import Consultant from "../../../../assets/DigitalMarketing/image/consultant.svg";

const ConsultantSummary = () => {
  const [selectedServiceType, setSelectedServiceType] = useState("this Month");

  const monthOptions = [
    { value: "this Month", label: "This Month" },
    { value: "previous Month", label: "Previous Month" },
  ];

  const { data: LeadData, refetch, isLoading } = useGetTopConsultantsQuery(selectedServiceType, {
    refetchOnMountOrArgChange: true,
  });

  const allConsultantsData = {
    id: "0",
    name: "All Consultants",
    count: LeadData?.data?.totalRevenue || 0,
    bgcolor: true,
  };

  const consultantList = LeadData?.data?.consultant?.map((consultant) => ({
    id: consultant.id,
    name: consultant.consultantName,
    speciality: consultant.speciality,
    count: consultant.totalRevenue,
    bgcolor: false,
  }));

  const data = [allConsultantsData, ...(consultantList || [])];

  return (
    <>
      <div className="d-flex justify-content-between">
        <div>
          <span className="dashboard-heading mb-4">Consultant Summary</span>
        </div>
        <div>
          <MonthFilterSelect
            value={selectedServiceType}
            onChange={setSelectedServiceType}
            options={monthOptions}
          />
        </div>
      </div>
      <div className="row p-1 align-items-center">
        {data.map((d) => (
          <div key={d.id} className="col-12">
            <div
              className="cards mt-2 d-flex justify-content-between align-items-center"
              style={{
                minHeight: "65px",
                backgroundColor: d.bgcolor ? "#E1D9F7" : "#FFF",
              }}
            >
              <div className="d-flex gap-3 align-items-center">
                <div>
                  <img src={d.bgcolor ? allConsultant : Consultant} alt="Consultant" />
                </div>
                <div>
                  {d.bgcolor ? (
                    <span className="f-32 fw-600">{d.name}</span>
                  ) : (
                    <div className="d-flex flex-column gap-1">
                      <span className="f-18 fw-400">{d.name}</span>
                      <span className="f-16 text-muted">{d.speciality}</span>
                    </div>
                  )}
                </div>
              </div>
              <div className="f-18 fw-500">{d.count}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ConsultantSummary;
